export default {
  handprintView: {
    large: 'Large',
    melody: 'Melody',
    instructions: {
      leftHandOneByOne: 'Play the left hand one note at a time.',
      leftHandTogether: 'Play all the notes of the left hand at the same time.',
      rightHandOneByOne: 'Play the right hand one note at a time.',
      rightHandTogether: 'Play all the notes of the right hand at the same time.',
      bothHandsOneByOne: 'Play the notes from bottom to top, one note at a time',
      rightTogetherThenLeft: 'Play the notes of the right hand at the same time then, while staying pressed, play the left hand one note at a time.',
      leftTogetherThenRight: 'Play the notes of the left hand at the same time then, while staying pressed, play the right hand one note at a time.',
      bothHandsTogether: 'Play the notes of the left hand and right hand at the same time.',
    },
  },
};